import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Popover from 'housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import CreateUpdateServicePro from './CreateUpdateServicePro.jsx'

const EmployeesListPopover = ({
  open,
  anchorEl,
  onClose,
  servicePros,
  onSelect,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
    onClose={onClose}
  >
    <Grid container direction="column">
      {Array.isArray(servicePros) && servicePros.map(servicePro => (
        <CreateUpdateServicePro
          key={servicePro.uuid}
          servicePro={servicePro}
          onServiceProSelected={onSelect}
        />
      ))}
    </Grid>
  </Popover>
)

EmployeesListPopover.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  anchorEl: PropTypes.object,
  servicePros: PropTypes.array,
  onSelect: PropTypes.func,
}

export default memo(EmployeesListPopover)
